import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IEvent } from './interfaces'
import { FilterState } from '../../components/events/EventFilter'
import { setParticipantViaToken } from '../participant/participant'
import { NavigateFunction } from 'react-router-dom'
import { AppThunk } from '../rootReducer'
import { formatPrice } from '../../utils'

export const initialState = {
  list: [] as IEvent[],
  loaded: false,
  error: false,
  filter: {} as Partial<FilterState>,
}

const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    setEvents(state, action) {
      state.loaded = true
      state.error = false

      state.list = action.payload.map((raw: IEvent) => ({
        ...raw,
        display_price:
          raw.price === 0 && raw.hide_price
            ? ''
            : `Normalpreis: ${
                raw.price === undefined
                  ? 'Kostenlos'
                  : raw.price === 0
                  ? 'Kostenlos'
                  : formatPrice(raw.price)
              }`,
      }))
    },
    loadingFailed(state, action) {
      state.loaded = false
      state.error = action.payload
      state.list = []
    },
    setFilter(state, action: PayloadAction<Partial<FilterState>>) {
      state.filter = action.payload
    },
  },
})

export default eventsSlice.reducer
export const { setEvents, loadingFailed, setFilter } = eventsSlice.actions

export const fetchEvents = (
  navigate: NavigateFunction,
  token?: string
): AppThunk => async (dispatch, getState) => {
  console.log('Fetching events...')
  try {
    const { baseUrl, programId } = getState().misc
    const response = await fetch(
      `${baseUrl}/api/programs/${programId}/events`,
      {
        //@ts-ignore
        credentials: window._is_react_dev_server ? "include" : "same-origin",
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )
    const data = await response.json()
    if (token) {
      console.log('Participant token found, fetching participant data...')
      await dispatch(setEvents(Array.isArray(data) ? data : []))
      return await dispatch(setParticipantViaToken(token, navigate))
    } else {
      dispatch(setEvents(Array.isArray(data) ? data : []))
    }
  } catch (error: unknown) {
    if (error instanceof Error) {
      return dispatch(loadingFailed(error.toString()))
    } else if (typeof error === "string") {
      return dispatch(loadingFailed(error))
    }
  }
}
